import styled from "styled-components"

export interface HeroLeftProps {
  background_color: string
}

export const StyledHero = styled.div<HeroLeftProps>`
  box-shadow: 0 0 16px ${(props) => props.theme.colors.darkGrey10};
  background: ${(props) =>
    props.background_color === "white" && props.theme.colors.white};
  background: ${(props) =>
    props.background_color === "ivory" && props.theme.colors.ivory};
  background: ${(props) =>
    props.background_color === "ivory_dark" && props.theme.colors.ivoryShadow};
  background: ${(props) =>
    props.background_color === "light_pink" && props.theme.colors.pinkLight};
  background: ${(props) =>
    props.background_color === "pink" && props.theme.colors.pink};
  background: ${(props) =>
    props.background_color === "dark_pink" && props.theme.colors.pinkDark};
  background: ${(props) =>
    props.background_color === "light_green" && props.theme.colors.greenLight};
  background: ${(props) =>
    props.background_color === "green" && props.theme.colors.green};
  background: ${(props) =>
    props.background_color === "dark_green" && props.theme.colors.greenDark};
  background: ${(props) =>
    props.background_color === "light_blue" && props.theme.colors.blueLight};
  background: ${(props) =>
    props.background_color === "blue" && props.theme.colors.blue};
  background: ${(props) =>
    props.background_color === "dark_blue" && props.theme.colors.blueDark};
  position: relative;
`

export const StyledHeroContainer = styled.div`
  display: flex;
  align-items: center;
  ${(props) => props.theme.mixins.container}

  @media (min-width: ${(props) => props.theme.breakPoints.tablet}) {
    min-height: 540px;
  }
`
export const StyledHeroCard = styled.div`
  position: relative;
  z-index: 1;
  max-width: 915px;
  margin: 64px 0;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    margin: 64px 0;
    max-width: 100%;
  }
`

export const StyledHeroIcon = styled.img`
  max-height: 80px;
  max-width: 80px;
  margin-bottom: 32px;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    max-height: 62px;
    max-width: 62px;
    margin-bottom: 24px;
  }
`

export const StyledHeroLabel = styled.p`
  color: ${(props) => props.theme.colors.darkGrey};
  text-transform: uppercase;
  margin: 0;
  font-size: 22px;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 16px;
    line-height: 20px;
  }
`

export const StyledHeroTitle = styled.h1`
  font-family: ${(props) => props.theme.fonts.circularBook};
  font-size: 80px;
  text-transform: uppercase;
  margin: 0 0 32px -6px;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 48px;
    margin: 0 0 24px -4px;
  }
`
export const StyledHeroDescription = styled.p`
  color: ${(props) => props.theme.colors.darkGrey};
  padding: 0;
  font-size: 22px;
  line-height: 26px;
  max-width: 70%;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 16px;
    line-height: 20px;
    max-width: 100%;
  }
`

export const StyledHeroButtons = styled.div`
  margin: 32px 0 0;
  display: flex;
  gap: 16px;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    margin: 24px 0 0;
  }

  & .button-v2--text {
    padding-top: 0;
    padding-bottom: 0;
    min-height: 0;
  }
`
export const StyledBgImg = styled.div`
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100%;

  & > div {
    height: 100%;
  }

  & img {
    width: 100%;
  }
`
